import {Tooltip} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {fileIconMap} from "../../contentUtils";
import type {ChecklistFileItem, ChecklistRelatedItem} from "../../types";
import {getFileDownloadInfo} from "../fileDownload";
import IconDownload from "../../../../assets/download.svg?react";
import styles from "./refCard.module.css";
import {bffApi} from "../../../chat/bffApi";
import {metricUuid, newMetricEvent} from "../../../chat/metrics";

export const FileRefCard = ({
    fileItem,
    relatedItem,
}: {
    fileItem: ChecklistFileItem;
    relatedItem?: ChecklistRelatedItem;
}) => {
    const {t} = useTranslation();
    const [trackInteraction] = bffApi.endpoints.trackInteraction.useMutation();

    const info = getFileDownloadInfo(fileItem, relatedItem);
    if (!info) return null;

    const Icon = fileIconMap[info.resourceTypeId];
    const tooltip = t("Phrase.DownloadFile", {file: fileItem.subname});

    return (
        <Tooltip label={tooltip} withArrow>
            <a
                href={info.href}
                download={info.downloadName}
                className={styles.refCard}
                data-pw="file-download"
                onClick={() => {
                    void trackInteraction({
                        ...newMetricEvent(),
                        action: "file_download_requested",
                        subjectId: metricUuid(fileItem.id),
                        source: "checklist",
                        format: "unknown",
                    });
                }}
            >
                <IconDownload
                    aria-hidden="true"
                    className={styles.downloadIcon}
                />
                {Icon && (
                    <Icon aria-hidden="true" className={styles.fileIcon} />
                )}
                <span className={styles.refLabel}>{fileItem.subname}</span>
            </a>
        </Tooltip>
    );
};
